import axios from "axios";
import md5 from 'md5';
import { API_URL } from "./api-uri";

const login = (email, password) => {

  return axios
    //.get(API_URL + "Users/filter?id=0&email=" + email + "&password=" + md5(password))
    .get(`${API_URL}Users/filter?id=0&email=${email}&password=${md5(password)}`)
    .then((response) => {
      if (response.data.id > 0) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
};


const forgotpassword = (email) => {
  return axios
    .get(`${API_URL}Users/forgotpassword?email=${email}`)
    .then();
};



const createAccount = (first_name, last_name, email, password) => {
  let user = { firstName: first_name, lastName: last_name, Email: email, type: null, active:true, password:md5(password) }
  return axios
    .put(API_URL + "Users/UpsertUser/0", user)
    .then((response) => {
      return response.data;
    }).catch((error) => {
      console.log(error)
      return null;
    });
};



const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("users");
  localStorage.removeItem("Company");
};

export default {
  login,
  logout,
  forgotpassword,
  createAccount
};